export type Action = {
	id: string;
	isEnabled: () => boolean;
	name: string;
};

export type ActionHandlerParams = {
	history: any;
	rowData: any;
	setConfirmationDialog: any;
	setForceUpdateRows: any;
};

export const ACTION_NAME = {
	REVERT: 'Revert'
};

export const ACTION_ID = {
	REVERT: 'revert'
};

export type ActionListParam = {
	hasPermission: any;
	appName: any;
};

export const ROUTE_ENDPOINTS = {
	GET_ZK_CHANGE_HISTORY: '/marketing/gameAdmin/zkRevertDashboard/getZkChangeHistory',
	REVERT_ZK_CONFIG: '/marketing/gameAdmin/zkRevertDashboard/revertZkConfig'
};

export const COLUMN_TITILE = {
	UPDATED_AT: 'Updated At',
	KEY_NAME: 'Key Name',
	UPDATED_BY: 'Updated By',
	GAME_NAME: 'Game Name',
	SERVICE_NAME: 'Service Name',
	NEW_VALUE: 'New value',
	OLD_VALUE: 'Old Value',
	DIFF: 'Diff'
};

export type ColData = {
	[key: string]: any;
	key: string;
	updatedby: string;
	game: string;
	serviceName: string;
	newValue: string;
	oldValue: string;
	updatedAt: string;
};

export type ValueCellParams = {
	value: {
		fullText: string;
		previewText: string;
	};
};

export type ColCellParams = {
	value: {
		oldData: string;
		newData: string;
	};
};
